
import BookingLogo from '@/core/components/BookingLogo.vue';
import OtherBookings from '@/core/components/OtherBookings.vue';
import Spinner from '@/core/components/Spinner.vue';
import { Booking, Project } from '@/models/bookings';
import { Driver, User } from '@/models/users';
import * as TelliqService from '@/services/telliq.service';
import { GETTERS } from '@/store/getters';
import { MUTATIONS } from '@/store/mutations';
import { emitter } from '@/utils/constants';
import moment from 'moment';
import { mapGetters } from 'vuex';
import BookingMixin from '../mixins/BookingDateMixin';

export default BookingMixin.extend({
  data() {
    return {
      loading: false,
      previous_bookings: [] as Booking[],
      next_bookings: [] as Booking[],
      created_booking: undefined as Booking | undefined,
      drivers: [] as Driver[],
      projects: [] as Project[],
    };
  },

  components: {
    Spinner,
    BookingLogo,
    OtherBookings,
  },

  async created() {
    this.$store.commit(MUTATIONS.SET_HEADER, {
      title: this.$t('bookings.headers.booking_done'),
      subtitle: '',
    });

    this.loading = true;
    try {
      this.created_booking = await TelliqService.getBookingById(this.booking.id);

      const { previous, next } = await this.getBeforeAndAfterBookings(this.created_booking, [this.booking.machine.id]);
      this.previous_bookings = previous;
      this.next_bookings = next;

      const [drivers, projects] = await Promise.all([TelliqService.getDrivers(), this.loadProjects()]);
      this.projects = projects;
      this.drivers = drivers;
    } catch (e) {
      emitter.emit('notify', {
        text: this.$t('core.errors.something_went_wrong'),
        color: 'error',
      });
    }

    this.loading = false;
  },

  computed: {
    ...mapGetters({
      booking: GETTERS.GET_CREATE_BOOKING,
    }),

    getPurpose(): string {
      return this.created_booking?.isPrivateUse
        ? this.$t('bookings.vehicle_type.private')
        : this.$t('bookings.vehicle_type.business');
    },

    getProject(): string | undefined {
      const project = this.projects.find((project) => project.projectId === this.created_booking?.project?.id);
      if (!project?.description) return project?.name;
      return `${project.name} - ${project.description}`;
    },
  },

  methods: {
    async loadProjects(): Promise<Project[]> {
      try {
        const user: User = this.$store.getters[GETTERS.GET_USER];
        const user_info = await TelliqService.getUserInfo(user.id);
        const projects = await TelliqService.getProjects(user_info.companyId);

        return projects.filter((project) => {
          if (project.active === false) return false;
          if (project.startUtcTime && moment(project.startUtcTime, 'YYYY-MM-DD HH:mm:ss').isAfter()) return false;
          if (project.endUtcTime && moment(project.endUtcTime, 'YYYY-MM-DD HH:mm:ss').isBefore()) return false;
          return true;
        });
      } catch (e) {
        emitter.emit('notify', {
          text: this.$t('core.errors.something_went_wrong'),
          color: 'error',
        });
      }
      return [];
    },
  },
});
